import { render, staticRenderFns } from "./ModalCadastroAtestado.vue?vue&type=template&id=03630eea"
import script from "./ModalCadastroAtestado.vue?vue&type=script&lang=js"
export * from "./ModalCadastroAtestado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports